import React from 'react';

import Tooltip from '~/components/core/Atomic/Tooltip';

const AutomaticEmailMessageSection: React.FC = () => {
  return (
    <div>
      <Tooltip title="Sent Automatically Acknowledgement Email">
        <div className="max-w-full truncate text-sm">
          Sent Automatically <span className="mx-1 text-blue-400">•</span> Acknowledgement Email
        </div>
      </Tooltip>
    </div>
  );
};

export default AutomaticEmailMessageSection;
